export enum AvailableItemsCardEvents {
  OUT_OF_ITEMS = 'outOfItems',
  HAS_AVAILABLE_ITEMS = 'hasAvailableItems',
}
